import React from 'react';
import styled from '@emotion/styled';

import Container from 'components/Container';
import News from './sections/News';
import VideoBar from './sections/VideoBar';
import ImageBar from './sections/ImageBar';
import Toolbox from './sections/Toolbox';
// import Articles from './sections/Articles';
import Advertisement from './sections/Advertisement';
import Sidebar from './Sidebar/Sidebar';
import SocialMedia from 'components/SocialMedia';
import ScrollToTopButton from 'components/ScrollToTopButton';

import vw from 'styles/utils';
import media from 'styles/media';

function Home() {
  return (
    <Root>
      <StyledContainer>
        <LeftCol>
          <News />
          <ImageBar />
          <Toolbox />
          <VideoBar />
          {/* <Articles /> */}
          <Advertisement />
        </LeftCol>
        <RightCol>
          <Sidebar />
        </RightCol>
      </StyledContainer>
      <SocialMedia />
      <ScrollToTopButton />
    </Root>
  )
}

const Root = styled.main``;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  ${vw('padding-top', 30, 30)}
  ${vw('padding-bottom', 50, 90)}

  @media ${media.desktop} {
    flex-direction: row;
  }
`;

const LeftCol = styled.div`
  @media ${media.desktop} {
    width: 66%;
  }
`;

const RightCol = styled.div`
  @media ${media.desktop} {
    width: 34%;
  }
`;

export default Home
